"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLI_HOOK = void 0;
/**
 * The mutate hook to use when adding CLI commands.
 * @remarks
 * The payload is an instance of yargs, and there is no context.
 */
exports.CLI_HOOK = 'feature:cli';
//# sourceMappingURL=Scriptable.js.map